/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Ajaxinate
  document.addEventListener("DOMContentLoaded", function() {
    const paginationElement = document.getElementById("AjaxinatePagination");
    
    if (paginationElement) {
      paginationElement.style.height = "0px";
      paginationElement.style.overflow = "hidden";

      function changeStyle() {  
        const nextPage = paginationElement.querySelector("#paginationNext");
        nextPage.classList.remove("pagination-custom__arr");
        nextPage.style.position = "absolute";
      }

      changeStyle();

      const endlessScroll = new Ajaxinate({
        container: "#CollectionLoop",
        loadingText: `<img src="//ateliers-auguste.fr/cdn/shop/t/15/assets/loading_25x.gif?v=97954329044969808271742387467">`,
        callback: changeStyle
      });
    }
  });

  /*
  Check updateHistoryState in theme.js to remove variant query in url
  if (window.location.href.includes("/products")) {
    const cleanHref = window.location.href.split("?variant")[0];
    //window.location.href = cleanHref;
  }*/
})();
